import { render, staticRenderFns } from "./UploadAndPreviewImage.vue?vue&type=template&id=0273a262&scoped=true"
import script from "./UploadAndPreviewImage.vue?vue&type=script&lang=js"
export * from "./UploadAndPreviewImage.vue?vue&type=script&lang=js"
import style0 from "./UploadAndPreviewImage.vue?vue&type=style&index=0&id=0273a262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273a262",
  null
  
)

export default component.exports